/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import { Picture } from 'models';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { COLOR } from 'config/constants';
import ImageGallery from 'react-image-gallery';
import 'react-image-lightbox/style.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'react-image-gallery/styles/scss/image-gallery.scss';

const useStyles = makeStyles({
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    width: 80,
    height: 80,
    color: COLOR.WHITE,
    marginBottom: 10,
    zIndex: 2,
  },
  icon: {
    fontSize: 40,
  },
});
interface Props {
  pictures: Picture[];
  setImageCarouselOpen: (open: boolean) => void;
  setImageCarouselPictures: (pictures: Picture[]) => void;
}

function ImagesGallery(props: Props) {
  const { setImageCarouselOpen, setImageCarouselPictures, pictures } = props;
  const classes = useStyles();

  const items = pictures.map((picture) => {
    return {
      original: picture.url,
      thumbnail: picture.thumbnail_url,
      originalHeight: 600,
      originalWidth: 800,
    };
  });

  const onClose = () => {
    setImageCarouselOpen(false);
    setImageCarouselPictures([]);
  };

  return (
    <div>
      <IconButton className={classes.closeButton} onClick={onClose}>
        <CloseRoundedIcon className={classes.icon} />
      </IconButton>
      <ImageGallery items={items} />
    </div>
  );
}

export default ImagesGallery;
